import type { AxiosError } from "axios";
import { httpInstance } from "@/services/httpInstance";
import type {
  BankCatalogItem,
  BusinessDetailCatalogItem,
  CatalogServiceResponse,
  MunicipalityCatalogItem,
  NeighborhoodCatalogItem,
  ProvinceCatalogItem,
  SectorCatalogItem,
} from "./types";

const getCatalogResponse = async <T,>(
  endpoint: string
): Promise<CatalogServiceResponse<T>> => {
  let res: CatalogServiceResponse<T>;

  await httpInstance
    .get<T[]>(endpoint)
    .then((data) => {
      res = data;
    })
    .catch((err: AxiosError) => {
      res = err.response;
    });

  return res;
};

export const getAssistedAffiliationProvinces = () => {
  const endpoint = "/frontlabels/v1/addresses/provinces/all";
  return getCatalogResponse<ProvinceCatalogItem>(endpoint);
};

export const getAssistedAffiliationMunicipalities = (provinceId: string) => {
  const endpoint = `/frontlabels/v1/addresses/provinces/${provinceId}/municipalities/all`;
  return getCatalogResponse<MunicipalityCatalogItem>(endpoint);
};

export const getAssistedAffiliationSectors = (municipalityId: string) => {
  const endpoint = `/frontlabels/v1/addresses/municipalities/${municipalityId}/zones/all`;
  return getCatalogResponse<SectorCatalogItem>(endpoint);
};

export const getAssistedAffiliationNeighborhoods = (sectorId: string) => {
  const endpoint = `/frontlabels/v1/addresses/zones/${sectorId}/neighborhoods/all`;
  return getCatalogResponse<NeighborhoodCatalogItem>(endpoint);
};

export const getAssistedAffiliationBusinessDetails = () => {
  const endpoint = "/frontlabels/v1/business/details";
  return getCatalogResponse<BusinessDetailCatalogItem>(endpoint);
};

export const getAssistedAffiliationBanks = () => {
  const endpoint = "/frontlabels/v1/banks/all";
  return getCatalogResponse<BankCatalogItem>(endpoint);
};
